// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"aac5eae7","338":"12296db3","466":"243cccec","544":"f3e71d2c","576":"ad606728","753":"052625b7","775":"ccb6077e","823":"57e4c79d","990":"2564ab93"}[chunkId] + ".js";
};